//@flow
import * as React from "react"
import styled from "styled-components"
import { CenteredIndicator } from "../Indicators"

const Container = styled.div`
  position: relative;
  flex: 1;
`
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
`
const Loader = ({
  loading,
  children
}: {
  loading: boolean,
  children?: ?React.ChildrenArray<React.Element<*>>
}) => (
  <Container>
    {loading ? (
      <Overlay>
        <CenteredIndicator />
      </Overlay>
    ) : (
      ""
    )}
    {children}
  </Container>
)

export default Loader



// WEBPACK FOOTER //
// ./src/UI/Loader/index.js